import { ScrollTrigger } from "gsap/ScrollTrigger";
export default class LoadMoreCareers {

    constructor() {
        this.settings = {
            $careersList: $(".js-careers-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$careersList != null) {

            let careersList = this.settings.$careersList; // The container element that holds the list of careers
            let loadNr = $('#js-nr-careers-default').val(); // The number of careers to load
            let loadMoreBtn = $(".js-load-more-careers"); // The button that triggers the loading of more careers

            function careersTypeList() {
                // Remove hidden class from all the careers
                $('.js-careers-single').removeClass('hidden');

                careersList.find('.js-careers-single').each(function (index) {

                    // Hide careers that have a higher index than the number of careers to load
                    if (index >= loadNr) {
                        $(this).addClass('hidden');
                    }
                });
            }

            careersTypeList();

            // Hide the load more button if there are no more reports to load initially
            if (careersList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            // Load more careers when the button is clicked
            loadMoreBtn.on('click',  (e) => {

                const $this = e.currentTarget;

                let morecareers =  careersList.find('.hidden'); // The careers that are currently hidden
                let counter = 0; // Counter to keep track of the number of careers that have been shown
                morecareers.each(function () {

                    // Stop the loop when the number of careers that have been shown is equal to the number of careers to load
                    if (counter >= loadNr) {
                        return false;
                    }

                    // Increment the counter
                    counter++;

                    // Show the careers
                    $(this).removeClass('hidden');
                });

                // Hide the load more button if there are no more careers to load
                if (careersList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }

                ScrollTrigger.refresh();
            });

        }

    }
};

new LoadMoreCareers();